var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAccountability = function SvgAccountability(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 68,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#accountability_svg__a)",
    d: "M46.159 35.508v28.167c0 2.682-1.291 4-3.92 4H3.924C1.33 67.675 0 66.344 0 63.743V7.259C0 4.655 1.327 3.326 3.92 3.326c1.793-.001 3.585-.005 5.378.002.89.003 1.423.448 1.443 1.176.02.756-.533 1.237-1.457 1.24-1.792.007-3.585.002-5.377.003-1.219 0-1.51.286-1.51 1.492q-.003 28.28 0 56.56c0 1.131.31 1.454 1.398 1.454q19.308.003 38.615 0c1.022 0 1.352-.325 1.353-1.339V7.054c-.001-.97-.34-1.302-1.31-1.305-1.842-.005-3.684.002-5.527-.003-.924-.003-1.488-.478-1.479-1.223.01-.741.57-1.193 1.506-1.195q2.801-.009 5.602 0c2.187.008 3.6 1.43 3.602 3.637.004 9.515.002 19.03.002 28.544"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#accountability_svg__b)",
    d: "M60.334 30.743c0 5.663.007 11.326-.012 16.99a4.5 4.5 0 0 1-.283 1.533c-1.124 2.955-2.289 5.894-3.428 8.843-.233.602-.544 1.098-1.256 1.098-.715 0-1.023-.506-1.254-1.104-1.15-2.971-2.317-5.936-3.454-8.913a3.8 3.8 0 0 1-.255-1.315c-.014-11.352-.019-22.703-.006-34.055.004-3.96 3.581-6.472 6.999-4.905 1.99.913 2.937 2.578 2.944 4.763.015 5.688.005 11.376.005 17.065M57.88 47.109v-28.93h-5.039v28.93zm-5.072-31.46h5.122c0-.814.04-1.568-.009-2.316-.089-1.37-1.16-2.406-2.467-2.45-1.36-.045-2.498.925-2.633 2.335-.075.79-.013 1.594-.013 2.43m4.535 33.954h-3.97l1.984 5.092z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#accountability_svg__c)",
    d: "M23.099 9.064c-2.413 0-4.826.003-7.239-.001-1.767-.003-2.718-.965-2.723-2.747-.004-1.232-.008-2.464 0-3.696.011-1.592.996-2.612 2.55-2.614q7.387-.011 14.775 0c1.583.001 2.548.982 2.561 2.588.011 1.333.017 2.666-.003 3.998-.022 1.457-1.008 2.456-2.459 2.466-2.487.019-4.975.005-7.462.006m-7.53-2.472h15.024v-4.13H15.568z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#accountability_svg__d)",
    d: "M30.213 25.383c-2.265 0-4.53.003-6.794-.002-.963-.002-1.479-.425-1.486-1.197-.007-.78.508-1.22 1.461-1.22q6.87-.006 13.738 0c.932 0 1.465.464 1.45 1.233-.013.74-.529 1.18-1.425 1.183-2.315.007-4.63.002-6.944.003"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#accountability_svg__e)",
    d: "M30.317 37.462c2.264 0 4.53-.003 6.794.001.942.002 1.474.448 1.472 1.213-.003.762-.534 1.205-1.48 1.205q-6.832.005-13.663 0c-.975 0-1.489-.408-1.507-1.176-.02-.804.505-1.24 1.515-1.242 2.29-.004 4.579-.001 6.869-.001"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#accountability_svg__f)",
    d: "M30.24 54.384c-2.264 0-4.529.002-6.793-.002-1.008-.001-1.534-.44-1.514-1.244.02-.768.531-1.174 1.508-1.174q6.831-.005 13.663 0c.945 0 1.477.443 1.479 1.206.002.764-.531 1.21-1.473 1.212-2.29.005-4.58.002-6.87.002"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#accountability_svg__g)",
    d: "M11.691 39.974c.217-.198.4-.352.566-.52 1.444-1.456 2.883-2.916 4.327-4.371.73-.736 1.384-.83 1.94-.291s.482 1.254-.222 1.97a1793 1793 0 0 1-5.486 5.544c-.812.817-1.348.815-2.157.005-.865-.866-1.729-1.735-2.583-2.613-.607-.624-.659-1.35-.154-1.86.524-.528 1.193-.483 1.836.153.62.616 1.222 1.252 1.933 1.983"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#accountability_svg__h)",
    d: "m11.697 25.529 4.728-4.787c.879-.89 1.508-1.017 2.098-.428.577.575.446 1.274-.403 2.132-1.757 1.778-3.514 3.558-5.276 5.332-.849.855-1.368.854-2.21.008a469 469 0 0 1-2.48-2.507c-.695-.707-.777-1.434-.232-1.967.556-.545 1.212-.459 1.94.284.595.605 1.17 1.23 1.835 1.933"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#accountability_svg__i)",
    d: "M11.735 54.587c.721-.767 1.345-1.447 1.987-2.109.925-.95 1.863-1.888 2.797-2.83.789-.796 1.419-.902 1.994-.342.574.56.462 1.276-.332 2.08q-2.613 2.643-5.227 5.284-.105.109-.212.213c-.73.702-1.293.713-2.001.01Q9.382 55.545 8.05 54.17c-.577-.595-.623-1.3-.149-1.806.512-.545 1.208-.52 1.836.11.65.653 1.27 1.34 1.998 2.113"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "accountability_svg__a",
    x1: -9.891,
    x2: 51.105,
    y1: 46.991,
    y2: 46.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accountability_svg__b",
    x1: 48.245,
    x2: 61.404,
    y1: 42.89,
    y2: 42.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accountability_svg__c",
    x1: 8.868,
    x2: 35.165,
    y1: 6.153,
    y2: 6.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accountability_svg__d",
    x1: 18.365,
    x2: 40.367,
    y1: 24.605,
    y2: 24.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accountability_svg__e",
    x1: 18.364,
    x2: 40.367,
    y1: 39.105,
    y2: 39.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accountability_svg__f",
    x1: 18.364,
    x2: 40.367,
    y1: 53.606,
    y2: 53.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accountability_svg__g",
    x1: 5.154,
    x2: 20.105,
    y1: 40.196,
    y2: 40.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accountability_svg__h",
    x1: 5.142,
    x2: 20.087,
    y1: 25.699,
    y2: 25.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accountability_svg__i",
    x1: 5.157,
    x2: 20.084,
    y1: 54.696,
    y2: 54.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })))));
};
export default SvgAccountability;